import { createTheme, responsiveFontSizes } from '@mui/material/styles'
import palette from './palette'

const theme = createTheme({
  palette,
  direction: 'rtl',
  spacing: 2,
  typography: {
    allVariants: {
      fontFamily: 'IRANSans',
    },
    h1: {
      fontSize: 24,
      fontWeight: 630
    },
    h4: {
      fontSize: 17,
      fontWeight: 630
    },
    h5: {
      fontSize: 14.4,
      fontWeight: 450
    },
    h6: {
      fontSize: 13.4,
      fontWeight: 390
    },
    body1: {
      fontSize: 13.5,
      fontWeight: 400
    },
    subtitle1: {
      fontSize: 15,
      fontWeight: 500,
    },
    subtitle2: {
      fontSize: 14.3,
      fontWeight: 410,
    },
    button: {
      fontSize: 16,
      marginTop: 10,
    },
  },
})

export default responsiveFontSizes(theme)
